const TIME_TRACKER_LOGOUT_EVENT = 'time-tracker:logout';

export const notifyTimeTrackerLogout = () => {
  window.dispatchEvent(new Event(TIME_TRACKER_LOGOUT_EVENT));
};

export const subscribeToTimeTrackerLogout = (listener: () => void) => {
  window.addEventListener(TIME_TRACKER_LOGOUT_EVENT, listener);

  return () => window.removeEventListener(TIME_TRACKER_LOGOUT_EVENT, listener);
};